import { ConversationAssistantUIModes } from './types';

export const getRovoChatBridgeProduct = (
	mode: ConversationAssistantUIModes | undefined,
	isFullScreen: boolean | undefined,
): string =>
	isFullScreen
		? 'rovo-chat.fullscreen'
		: `rovo-chat.${mode ?? ConversationAssistantUIModes.SIDEBAR}`;
